export default "__VITE_ASSET__qHWVkcHz__"